import React from 'react';
import ContactForm from '../ContactFrom'


const Contactpage = () => {

    return(
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-location"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Adresse</h2>
                                            <p>Marrakech, Medina En Face de Bab Agnaou N°: 30</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Email</h2>
                                            <p>contact@getriad.com</p>
                                            <p>getriad77@gmail.com</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-telephone"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Appelez Nous</h2>
                                            <p>+ (212) 06.69.91.48.63</p>
                                            <p>+ (212) 06.61.44.37.51</p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>Restons en contact !</h2>
                            <p>Une question ou un projet ? Contactez-nous pour la création
                                la rénovation ou l’achat de votre Riad à Marrakech.
                                Nous serons ravis de vous aider !</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm/>
                        </div>
                    </div>                
                </div>
            </div> 
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3397.5869670421757!2d-7.993720825106074!3d31.617775574169507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdafef000f8a327b%3A0xb6017a5a2ca36d59!2sGet%20Riad!5e0!3m2!1sfr!2sma!4v1739494726417!5m2!1sfr!2sma"  
                        title="Localisation de Get Riad"
                        width="600" 
                        height="450" 
                        style={{ border: "0" }}  
                        allowFullScreen  
                        loading="lazy"  
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
            </div>
            </section>
        </section>
     )
        
}

export default Contactpage;
